module.exports = __webpack_public_path__ + "img/Perforated_Steel2.19997e9f.png";